import React from 'react';
import "../../styles/Footerbar.css";
import { FaInstagram } from 'react-icons/fa';

const Footerbar = () => {
  return (
    <footer className="footer-bar">
      <div className='footer-content'>
        <p className="footer-info">
          © BIIYEON | 대표: 안우혁 |{/* 사업자등록번호: 123-45-67890 | */} 개인정보처리방침
        </p>

        <a
          href="https://www.instagram.com/biiyeon/"
          target="_blank"
          rel="noreferrer"
          className="footer-instagram"
          aria-label="BIIYEON 인스타그램"
        >
          <FaInstagram />
        </a>
      </div>
    </footer>
  );
};

export default Footerbar;


